


























import { computed, defineComponent, ref } from "@vue/composition-api";
import { ProcessedContentFiles, ProcessedFileData } from "@/types";
import AudioPlayer from "@/components/AudioPlayer";
import BaseIcon from "@/components/Base/BaseIcon";
import useGlobalAudioControllerHelper from "@/components/GlobalAudioPlayer/hooks/useGlobalAudioControllerHelper";

export default defineComponent({
  name: "AudioList",
  components: { AudioPlayer, BaseIcon },
  props: {
    fileList: { type: Object as () => ProcessedContentFiles | ProcessedFileData, required: true },
  },
  setup(props) {
    const { play, state } = useGlobalAudioControllerHelper(computed(() => props.fileList.accessed));
    const showAllFiles = ref(false);
    const filesToPrint = computed(() => {
      return showAllFiles.value ? props.fileList.accessed : props.fileList.accessed.slice(0, 3);
    });

    return {
      showAllFiles,
      filesToPrint,
      state,
      play,
    };
  },
});
